// @flow
import React, { Component } from "react";
import styles from "./Tag.module.css";

type Props = {
  tag: any
};

type State = {};

class Tag extends Component<Props, State> {
  render() {
    const { tag } = this.props;
    return tag && <span className={styles.tag}>{tag}</span>;
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachInfo/Tag/Tag.js